import React from 'react';
import DocumentCustom from './DocumentCustom';
import Image from './Image';
import Video from './video';
import styles from './card.module.css';
import { useSelector } from 'react-redux';
function Card({ cardData }) {
  const { isChatFullScreen } = useSelector((state) => ({
    isChatFullScreen: state.messages.isChatFullScreen,
  }));
  return (
    <div className={`${!isChatFullScreen ? styles.container : ''} rcw-message-content`}>
      {cardData?.media?.type === 'document' && (
        <DocumentCustom
          docLink={cardData?.media?.link || cardData?.link}
          docType={cardData?.media?.type}
          fileSize={1024}
        />
      )}
      {cardData?.media?.type === 'image' && (
        <Image src={cardData?.media?.link || cardData?.link} alt={''} />
      )}
      {cardData?.media?.type === 'video' && (
        <>
          <Video src={cardData?.media?.link || cardData?.link} type={'video/mp4'} />
          <p className={styles.cardDescMsg}>{cardData?.description}</p>
          {/* <a href={cardData?.media?.link} target='_blank' className={styles.cardMediaLink}>{cardData?.media?.link}</a> */}
        </>
      )}
      {/* {cardData?.choices.map((item, index) => (
        <div key={index}>
          {item.text && (
            <>
              <div className={styles.cardChoice}>
                <p>{item.text}</p>
              </div>
            </>
          )}
          {item.url && (
            <>
              <div className={styles.cardUrlMsg}>
                <span>
                  <img src="./images/linkLogo.png" alt="" width={12} height={12} />
                </span>
                <a
                  className={styles.cardUrlSpanMsg}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer">
                  {item.url}
                </a>
              </div>
            </>
          )}
        </div>
      ))} */}
    </div>
  );
}
export default Card;
